import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_8: FaireProductEntity = {
  token: "viverano-8",
  type: "product",
  name: "Duck Waddle - Organic Jacquard Knit Baby Blankets",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/407d7a9167e5146ec658f679f63abb21a82539a9139700da308d648754ee4cc5.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1742,1742,x59,y113,safe&width=720",
  priceDollars: 36.5,
  msrpDollars: 62,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_nursery-decor"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
